// data/languages/peul/categories/objets.ts

import { CategoryData } from '../../../../types/types';

export const objets: CategoryData = {
  // OBJETS DU QUOTIDIEN - Sources : lexique Pulaar-Français (planete-senegal.com/senegal/lexique_peul.php),
  // recoupé avec Wiktionary pour "laawol". Liste volontairement courte : seuls les mots
  // vérifiables via une source ont été retenus (cf. convention déjà suivie dans couleurs.ts).
  'Suudu (Maison)': { translation: 'La maison / la case', translationEn: 'The house / the hut', illustration: '🏠', audio: 'Ff-Suudu' },
  'Galle (Concession)': { translation: 'La concession, la maison familiale', translationEn: 'The family compound, the family home', illustration: '🏡' },
  'Danki (Banc)': { translation: 'Le banc en bois (sert aussi de lit collectif)', translationEn: 'The wooden bench (also used as a communal bed)', illustration: '🪑' },
  'Loode (Canari)': { translation: "Le canari à eau", translationEn: 'The water jar', illustration: '🏺' },
  'Lahal (Calebasse)': { translation: 'La calebasse', translationEn: 'The calabash', illustration: '🥥' },
  'Comcol (Vêtement)': { translation: 'Le vêtement', translationEn: 'The garment', illustration: '👕' },
  'Paade (Chaussures)': { translation: 'Les chaussures', translationEn: 'The shoes', illustration: '👡' },
  'Laana (Pirogue)': { translation: 'La pirogue', translationEn: 'The canoe', illustration: '🛶' },
  'Kaalisi (Argent)': { translation: "L'argent", translationEn: 'Money', illustration: '💰' },
  'Laawol (Route)': { translation: 'La route, le chemin', translationEn: 'The road, the path', illustration: '🛣️' },
};

export default objets;

export {};
